var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "deposit-form" }, [
    _vm.remitList.length > 0
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "remit-tabs" },
              _vm._l(_vm.remitList, function (remit, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    staticClass: "tab-btn",
                    class: { active: _vm.activeTab === index },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = index
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        匯款單 #" + _vm._s(index + 1) + "\n      "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._l(_vm.remitList, function (remit, index) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === index,
                      expression: "activeTab === index",
                    },
                  ],
                  staticClass: "progress-container",
                },
                [
                  _vm._m(0, true),
                  _c("div", { staticClass: "progress-steps" }, [
                    _c("div", { staticClass: "step active" }, [
                      _c("div", { staticClass: "step-icon" }, [_vm._v("1")]),
                      _c("div", { staticClass: "step-content" }, [
                        _c("h4", [_vm._v("匯款信息已提交")]),
                        _c("p", [
                          _vm._v(
                            "匯款金額：" +
                              _vm._s(remit.currency) +
                              " " +
                              _vm._s(remit.amount)
                          ),
                        ]),
                        _c("p", [_vm._v("提交時間：" + _vm._s(remit.time))]),
                      ]),
                    ]),
                    remit.status == 0
                      ? _c("div", { staticClass: "step" }, [
                          _c("div", { staticClass: "step-icon" }, [
                            _vm._v("2"),
                          ]),
                          _vm._m(1, true),
                        ])
                      : _vm._e(),
                    remit.status == 1
                      ? _c("div", { staticClass: "step active" }, [
                          _c("div", { staticClass: "step-icon" }, [
                            _vm._v("2"),
                          ]),
                          _c("div", { staticClass: "step-content" }, [
                            _c("h4", { staticStyle: { color: "red" } }, [
                              _vm._v("客服審核未通過"),
                            ]),
                            _c("p", [
                              _vm._v("審核時間：" + _vm._s(remit.auditTime)),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    remit.status == 3
                      ? _c("div", { staticClass: "step active" }, [
                          _c("div", { staticClass: "step-icon" }, [
                            _vm._v("2"),
                          ]),
                          _c("div", { staticClass: "step-content" }, [
                            _c("h4", { staticStyle: { color: "green" } }, [
                              _vm._v("客服審核通過"),
                            ]),
                            _c("p", [
                              _vm._v("審核時間：" + _vm._s(remit.auditTime)),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    remit.status != 3
                      ? _c("div", { staticClass: "step" }, [
                          _c("div", { staticClass: "step-icon" }, [
                            _vm._v("3"),
                          ]),
                          _vm._m(2, true),
                        ])
                      : _vm._e(),
                    remit.status == 3
                      ? _c("div", { staticClass: "step active" }, [
                          _c("div", { staticClass: "step-icon" }, [
                            _vm._v("3"),
                          ]),
                          _c("div", { staticClass: "step-content" }, [
                            _c("h4", { staticStyle: { color: "green" } }, [
                              _vm._v("已完成"),
                            ]),
                            _c("p", [
                              _vm._v("完成時間：" + _vm._s(remit.auditTime)),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "progress-header" }, [
      _c("h3", [_vm._v("匯款處理進度")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-content" }, [
      _c("h4", [_vm._v("客服審核中")]),
      _c("p", [_vm._v("預計審核時間：2小時内")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-content" }, [
      _c("h4", [_vm._v("待發貨")]),
      _c("p", [_vm._v("審核通過后將立即發貨")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }